// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__objNU","goBack":"page_goBack__oSEpM","header":"page_header__AkSbC","tips":"page_tips__nxnbK","empty":"page_empty__Gm75Y","btn_refresh":"page_btn_refresh__lkFqy"};